import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import backgroundImage from "../assets/background.webp";

const Home = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        color: "white",
        textAlign: "center",
        padding: "2rem",
        position: "relative",
      }}
    >
      {/* Main Content */}
      <Typography
        variant="h1"
        sx={{
          fontSize: { xs: "3.5rem", sm: "4rem" },
          fontWeight: 200,
          letterSpacing: "0.2rem",
          marginBottom: "1rem",
        }}
      >
        WELCOME TO
      </Typography>
      <Typography
        variant="h2"
        sx={{
          fontSize: { xs: "2.5rem", sm: "3rem" },
          fontWeight: 700,
          textTransform: "uppercase",
          marginBottom: "2rem",
        }}
      >
        INSIGHTHUB
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontSize: "1.5rem",
          fontWeight: 200,
          marginBottom: "2rem",
        }}
      >
        PRESS START TO BEGIN
      </Typography>
      <Box>
        <Button
          variant="contained"
          size="large"
          sx={{
            letterSpacing: "0.2rem",
            backgroundColor:(theme)=>theme.palette.accent.main,
            color:"primary.main",
            borderRadius: "50px",
            padding: "0.25rem 3rem",
            fontSize: "1.75rem",
          }}
          onClick={() => navigate("/intro")}
        >
          START
        </Button>
      </Box>
    </Box>
  );
};

export default Home;
